import { memo } from "react";
import { ActivityIndicator, ScrollView } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { CurrentRoutines } from "./CurrentRoutines";
import { CommonRoutines, type ProcessedSuggestion } from "./CommonRoutines";
import type { FC } from "react";
import type { AlarmRoutine } from "@src/services/api/types";

interface ChangeRoutineContentProps {
  isLoading: boolean;
  currentRoutines: AlarmRoutine[];
  suggestions: ProcessedSuggestion[];
  onEdit: (routine?: AlarmRoutine) => void;
  bottomInset: number;
  backgroundColor: string;
}

export const ChangeRoutineContent: FC<ChangeRoutineContentProps> = memo(
  ({ isLoading, currentRoutines, suggestions, onEdit, bottomInset, backgroundColor }) => {
    const { theme } = useUnistyles();

    return (
      <ScrollView
        style={{ flex: 1, backgroundColor: backgroundColor }}
        contentContainerStyle={{
          paddingBottom: bottomInset + theme.spacing["6xl"],
          flexGrow: 1,
        }}
        showsVerticalScrollIndicator={false}
      >
        {isLoading && (
          <View flex={1} justifyContent="center" alignItems="center" pt="9xl">
            <ActivityIndicator color={theme.colors.text} />
          </View>
        )}
        {!isLoading && (
          <>
            <CurrentRoutines routines={currentRoutines} onEdit={onEdit} />
            <CommonRoutines suggestions={suggestions} onSelect={onEdit} />
          </>
        )}
      </ScrollView>
    );
  },
);

ChangeRoutineContent.displayName = "ChangeRoutineContent";
